/**
 * auto-open-cart.js
 * Redirects to /cart after a product is added, and blocks duplicate
 * add-to-cart calls that can fire on mobile (single tap triggering
 * both touchend and click). Guards BOTH fetch and XMLHttpRequest.
 */
(function () {
  'use strict';

  // Don't run if we are already on the cart page
  if (window.location.pathname.indexOf('/cart') === 0) {
    return;
  }

  // Shared lock across fetch and XHR so a duplicate via either is blocked
  var addInProgress = false;

  function lockAdd() {
    addInProgress = true;
    setTimeout(function () {
      addInProgress = false;
    }, 1500);
  }

  function redirectToCart() {
    setTimeout(function () {
      window.location.href = '/cart';
    }, 200);
  }

  function isAddUrl(urlString) {
    return typeof urlString === 'string' && urlString.indexOf('/cart/add') !== -1;
  }

  /* ---------- Guard fetch ---------- */
  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = args[0];
      var urlString = typeof url === 'string' ? url : (url && url.url) || '';

      if (isAddUrl(urlString)) {
        if (addInProgress) {
          return Promise.reject(new Error('Duplicate add-to-cart blocked'));
        }
        lockAdd();

        var result = originalFetch.apply(this, args);
        result
          .then(function (response) {
            if (response && response.ok) {
              redirectToCart();
            }
            return response;
          })
          .catch(function () {});
        return result;
      }

      return originalFetch.apply(this, args);
    };
  }

  /* ---------- Guard XMLHttpRequest ---------- */
  var OriginalXHR = window.XMLHttpRequest;
  if (typeof OriginalXHR === 'function') {
    var originalOpen = OriginalXHR.prototype.open;
    var originalSend = OriginalXHR.prototype.send;

    OriginalXHR.prototype.open = function (method, url) {
      this._isAddToCart = isAddUrl(url);
      return originalOpen.apply(this, arguments);
    };

    OriginalXHR.prototype.send = function () {
      var self = this;

      if (self._isAddToCart) {
        // Block a duplicate add fired within the lock window
        if (addInProgress) {
          return; // do not send the duplicate request
        }
        lockAdd();

        self.addEventListener('load', function () {
          if (self.status >= 200 && self.status < 300) {
            redirectToCart();
          }
        });
      }

      return originalSend.apply(this, arguments);
    };
  }
})();